angular.module('impactx.panel').directive('ixThemeWorldPanel', function () {
    return {
        restrict: 'EA',
        controller: 'ThemeWorldPanelCtrl',
        controllerAs: 'themeWorldPanelCtrl',
        scope: true,
        bindToController: {
            themeWorld: "="
        },
        templateUrl: 'shared/panel/templates/themeworld.panel.tmpl.html'
    }
});